module.exports = __webpack_public_path__ + "e6f64767e5b55e299d886a73f4a28cd3.png";